import { useSessionStore, SESSION_STATUS_EXPIRED, SESSION_STATUS_REAUTHENTICATING } from '../../contexts/SessionStore'
import ConfirmModal from '../ConfirmModal/ConfirmModal'
import { useShallow } from 'zustand/react/shallow'

const SessionExpiredModal = () => {
  const { status, lastError, pendingSave, startReauthentication } = useSessionStore(
    useShallow((state) => ({
      status: state.status,
      lastError: state.lastError,
      pendingSave: state.pendingSave,
      startReauthentication: state.startReauthentication,
    }))
  )

  const isReauthenticating = status === SESSION_STATUS_REAUTHENTICATING

  return (
    <ConfirmModal
      title="Session expirée"
      text={
        <div>
          <p>La session doit être renouvelée avant de sauvegarder.</p>
          {pendingSave?.draftKey ? (
            <p>Le brouillon local est conservé et la page ne sera pas quittée.</p>
          ) : (
            <p>La page reste ouverte pour conserver vos modifications en cours.</p>
          )}
          {lastError && <p>{lastError}</p>}
        </div>
      }
      txtConfirm={isReauthenticating ? 'Reconnexion...' : 'Reconnecter'}
      isOpen={status === SESSION_STATUS_EXPIRED || isReauthenticating}
      setIsOpen={() => {}}
      onConfirm={startReauthentication}
      closeOnConfirm={false}
      dismissable={false}
      hideCancel
      isLoading={isReauthenticating}
    />
  )
}

export default SessionExpiredModal
